import React, {PureComponent} from "react";
import {Modal, Form, Input, Spin} from "antd";
import PropTypes from 'prop-types'


class FormModal extends PureComponent {


    onOk = () => {
        const {onOk, form} = this.props;
        form.validateFields((errors, values) => {
            if (!errors) {
                onOk(values);
            }
        })
    };

    render() {
        const {fields, form, record, loading, ...restProps} = this.props;
        return (
            <Modal {...restProps}
                   onOk={this.onOk}
                   afterClose={() => form.resetFields()}
            >
                <Spin spinning={loading}>
                    {fields.map(item => {
                        const {title, dataIndex, rules, initialValue, render, visible = true} = item;
                        const vv = (typeof visible) === 'function' ? visible(record) : visible
                        return (
                            <Form.Item key={dataIndex} label={title} style={vv ? {} : {display: 'none'}}>
                                {form.getFieldDecorator(dataIndex, {
                                    rules: rules,
                                    initialValue: initialValue ? initialValue(record) : (record ? record[dataIndex] : undefined)
                                })(
                                    render || <Input />
                                )}
                            </Form.Item>
                        )
                    })}
                </Spin>
            </Modal>
        )
    }
}

FormModal.propTypes = {
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            dataIndex: PropTypes.string.isRequired,
            rules: PropTypes.array,
            render: PropTypes.element,
            visible: PropTypes.bool,
        })
    ).isRequired,
    record: PropTypes.object,
    loading: PropTypes.bool,
};


FormModal.defaultProps = {
    loading: false,
    record: {},
};

export default Form.create()(FormModal);